import { Flare } from "@mui/icons-material";
import { Container, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { Box } from "@mui/system";
export default () => {
    const sectionHeading = 'Solar Token Use Cases'
    return (
        <>
            <Box mt={10} id="useCase" pt={15}>
                <Container>
                    <Box sx={{ position: 'relative', textAlign: 'center' }} mb={10}>
                        <Box > <span className="textStroke"><Typography color='white' fontSize={{ xs: '31px', sm: '50px', md: '74px' }} sx={{ letterSpacing: '0.12em' }}>
                            {sectionHeading}
                        </Typography></span></Box>
                        <Box sx={{ position: 'absolute', top: '10%', right: 0, left: 0, margin: 'auto' }}>
                            <Typography color='white' fontSize={{ xs: '25px', sm: '40px', md: '64px' }} sx={{ letterSpacing: '0.12em' }}>
                                {sectionHeading}
                            </Typography>
                        </Box>
                    </Box>
                    <Box textAlign='center'>
                        <List sx={{display:'inline-block'}}>
                            {
                                ['Governance',
                                    'Lotto',
                                    'Staking',
                                    'Farming',
                                    'Exchange Fees',
                                    'Launchpad Fees',].map((item) => {
                                        return <ListItem>
                                            <ListItemIcon> <Flare sx={{ color: 'white' }} /> </ListItemIcon>
                                            <ListItemText>
                                                <Typography fontSize={{ xs: "18px", md: '25px' }} sx={{ color: 'white' }} >{item}</Typography>
                                            </ListItemText>
                                        </ListItem>
                                    })
                            }
                         
                        </List>
                    </Box>
                </Container>
            </Box>
        </>
    )
}
